<!--
    描述：会议室管理  -- 编辑页
    时间： 2020/9/30
    Created by zl
-->
<template>
    <div class="filed-info-layout">
        <div class="common-top" ref="formRef">
            <el-form label-width="130px" :model="msgForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="sname" label="场地名称：">
                            <span>{{ adressObj.sname }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="unit" label="场地所属单位：">
                            <span>{{ adressObj.tenantSname }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="场地地址：" prop="address">
                            <span
                                >{{ adressObj.detailAdd }}
                                {{ adressObj.address }}</span
                            >
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider content-position="left">会议室信息</el-divider>

            <div class="add-area">
                <div class="add-box">
                    <el-form
                        label-width="130px"
                        :model="meetingForm"
                        :rules="meetingRule"
                        ref="editMeeting"
                    >
                        <el-row>
                            <el-col>
                                <el-form-item label="会议室名称：" prop="sname">
                                    <el-input
                                        v-model="meetingForm.sname"
                                        placeholder="请输入会议室名称"
                                        maxlength="6"
                                        show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="会议室类型" prop="type">
                                    <el-checkbox-group v-model="typeList">
                                        <el-checkbox
                                            v-for="(item, index) in hyslx"
                                            :key="'hyslx' + index"
                                            :label="item.value"
                                            >{{ item.sname }}</el-checkbox
                                        >
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item
                                    label="场地容纳人数"
                                    prop="galleryful"
                                >
                                    <el-input
                                        placeholder="请输入场地容纳人数"
                                        type="number"
                                        v-model="meetingForm.galleryful"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="会议室价格" prop="price">
                                    <el-input
                                        type="number"
                                        v-model="meetingForm.price"
                                    >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="会议室配置信息">
                                    <el-checkbox-group v-model="baseCheck">
                                        <el-checkbox
                                            v-for="(item, index) in hyspzxx"
                                            :key="'hyspzxx' + index"
                                            :value="item.value"
                                            :label="item.value"
                                            >{{ item.sname }}</el-checkbox
                                        >
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="场地照片">
                                    <myUpload
                                        ref="imgUpload"
                                        listType="picture-card"
                                        tableName="operate_meeting"
                                        forDatabase="meeting"
                                        :aid="mId"
                                        :acceptType="acceptArr"
                                        :maxNum="4"
                                    ></myUpload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="foot-btn">
                <el-button size="small" @click="goBack">返回</el-button>
                <el-button
                    type="primary"
                    class="btn-blue"
                    size="small"
                    @click="submitForm"
                    >保存</el-button
                >
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import {
    operMeetingEcho,
    saveOrUpdateOperateMeeting
} from 'api/modules/fieldManagement'
export default {
    components: {},
    props: {
        mId: {
            type: String,
            default: ''
        },
        sId: {
            type: String,
            default: ''
        },
        adressObj: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            msgForm: {}, //场地信息
            meetingForm: {}, //会议室信息
            baseCheck: [],
            typeList: [],
            acceptArr: ['jpg', 'png'],
            meetingRule: {
                sname: [
                    {
                        required: true,
                        message: '会议室名称不能为空',
                        trigger: 'blur'
                    }
                ],
                type: [
                    {
                        required: true,
                        message: '会议室类型不能为空',
                        trigger: 'blur'
                    }
                ],
                galleryful: [
                    {
                        required: true,
                        message: '容纳人数不能为空',
                        trigger: 'blur'
                    }
                ],
                price: [
                    {
                        required: true,
                        message: '会议室价格不能为空',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    mounted() {
        this.mId != '' ? this.getMeetingInfo() : ''
    },
    methods: {
        // 获取会议室信息
        getMeetingInfo() {
            operMeetingEcho({
                id: this.mId
            }).then(d => {
                if (d.code == 0) {
                    this.meetingForm = d.data
                    this.baseCheck = d.data.configuration.split(',')
                    this.typeList = d.data.type.split(',')
                }
            })
        },

        // 返回
        goBack() {
            if (this.routeQuery == 'edit') {
                this.$router.push({ path: '/room-management' })
            } else if (this.routeQuery == 'detail') {
                this.$router.push({ path: '/field-management' })
            }
        },

        // 保存编辑
        submitForm() {
            this.$refs.editMeeting.validate(valid => {
                if (valid) {
                    let operateMeetingList = Object.assign({}, this.meetingForm)
                    operateMeetingList.configuration = this.baseCheck.join(',')
                    let type = this.typeList.join(',')
                    saveOrUpdateOperateMeeting({
                        id: this.sId,
                        operateMeetingList: {
                            id: this.mId,
                            siteId: this.sId,
                            sname: operateMeetingList.sname,
                            type,
                            isFlag: 1,
                            galleryful: operateMeetingList.galleryful,
                            price: operateMeetingList.price,
                            configuration: operateMeetingList.configuration,
							newFlag: '1'
                        }
                    }).then(d => {
                        if (d.code == 0) {
                            this.$message.success(d.msg)
                            this.uploadToService()
                            this.$emit('on-reset')
                            this.goBack()
                        }
                    })
                } else {
                    this.$message.warning('请完善表单！')
                }
            })
        },

        // 上传到服务器
        uploadToService() {
            this.$refs.imgUpload.fileSend(this.meetingForm.id)
        },
    },
    computed: {
        ...mapState('place_dict', { hyslx: state => state.hyslx }),
        ...mapState('place_dict', { hyspzxx: state => state.hyspzxx }),
        routeQuery() {
            return this.$route.query.type
        }
    }
}
</script>
<style lang='less' scoped>
.filed-info-layout {
    .common-top {
        padding: 20px 0;
        .special-item {
            /deep/ .el-form-item__content {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
            }
            /deep/ .el-select {
                flex: 1;
                width: 33.3%;
            }
            /deep/ .el-select + .el-select {
                margin-left: 15px;
            }
            .detail-msg {
                margin-top: 15px !important;
            }
        }
    }
    .el-icon-circle-plus {
        font-size: 30px;
        color: #009900;
        cursor: pointer;
    }
    .add-meeting {
        color: #256ccb;
        font-size: 12px;
        margin-left: 10px;
        cursor: pointer;
    }
    .add-area {
        .add-box {
            width: 60%;
            padding: 20px;
            position: relative;
        }
        .del-btn {
            position: absolute;
            cursor: pointer;
            background-color: #dcdfe6;
        }
    }
    .foot-btn {
        text-align: center;
    }
    /deep/ .el-input-group__append {
        background-color: #256ccb;
        color: #fff;
    }
}
</style>
